import React from 'react';
import { TrendingUp } from 'lucide-react';
export function OddsTicker() {
  const metrics = ['↑ 340% Avg. Organic Traffic Growth', '€2.4M Revenue Generated for Partners', '↑ 89% Conversion Rate Improvement', '47 Active Affiliate Networks', '↑ 12.6x Average ROI', '54,600+ Monthly Organic Visitors', '↑ 593% Player Signup Increase', '€94,200 Avg. Monthly Affiliate Revenue'];
  const doubledMetrics = [...metrics, ...metrics];
  return <div className="bg-[#00ff88] py-3 overflow-hidden" data-id="element-92">
      <div className="flex animate-ticker" data-id="element-93">
        {doubledMetrics.map((metric, index) => <div key={index} className="flex items-center space-x-2 px-8 whitespace-nowrap" data-id="element-94">
            <TrendingUp className="text-[#0a1a0f]" size={16} data-id="element-95" />
            <span className="text-[#0a1a0f] font-mono font-semibold text-sm sm:text-base" data-id="element-96">
              {metric}
            </span>
          </div>)}
      </div>
    </div>;
}